import { render, staticRenderFns } from "./HomepageBody.vue?vue&type=template&id=38290ada&scoped=true&"
import script from "./HomepageBody.vue?vue&type=script&lang=js&"
export * from "./HomepageBody.vue?vue&type=script&lang=js&"
import style0 from "./HomepageBody.vue?vue&type=style&index=0&id=38290ada&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38290ada",
  null
  
)

export default component.exports